import Home, { CTAStart, NewsBar } from 'app/developer-v3/pages/home';

export { CTAStart, NewsBar };

export default {
  isAuthRequired: true,
  routes: {
    '.': Home,
  },
};
